<ws-modal-wrapper headerLabel="Accrual Paid Date Precedences"
                  [hideSave]="!canEdit"
                  (cancel)="cancel()"
                  (save)="save()"
                  [cancelLabel]="canEdit ? 'Cancel' : 'Close'">
    <div class="ws-flex-container-vertical ws-stretch">
        <table class="table table-striped table-condensed">
            <tr>
                <th>Selected Date Type</th>
                <th>Order of Precedence</th>
            </tr>
            @for (item of accrualPaidDatePrecedences; track item) {
                <tr>
                    <td>
                        <div class="checkbox" style="margin: 0 auto 0;">
                            <label>
                                <input type="checkbox"
                                       [disabled]="!canEdit"
                                       [(ngModel)]="item.isSelected"
                                       (change)="onChangeIsSelected(item)">
                                {{ item.accrualPaidDateTypeName }}
                            </label>
                        </div>
                    </td>
                    <td>
                        <span style="margin: 0 auto 0;">{{ item.orderOfPrecedence }}</span>
                    </td>
                </tr>
            }
        </table>
    </div>
</ws-modal-wrapper>
